import React from "react";
import { Link } from "react-router-dom";

const LOGO_DARK = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_Dark_01.png`;
const LOGO_DARK_TAGLINE = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_Dark_02.png`;

/**
 * @param {{ variant?: 'default' | 'login' | 'register' }} props
 * `login` / `register`: tagline lockup + distinct copy (not marketing home).
 */
const MaxAuthBrandPanel = ({ variant = "default" }) => {
  const isBranded = variant === "login" || variant === "register";

  return (
    <div className={`max-auth-brand ${isBranded ? "max-auth-brand--branded" : ""}`}>
      <div className="max-auth-brand__grid" aria-hidden="true" />
      <div className="max-auth-brand__inner">
        <Link to="/" className="max-auth-brand__back">
          ← Back to website
        </Link>
        <Link to="/" className="max-auth-brand__logo-wrap">
          {isBranded ? (
            <img
              src={LOGO_DARK_TAGLINE}
              alt="MaX Consulting — zero defect, zero downtime, zero incident"
              className="max-auth-brand__logo max-auth-brand__logo--tagline max-auth-brand__logo--tagline-scale"
              width={330}
              height={108}
            />
          ) : (
            <img
              src={LOGO_DARK}
              alt="MaX Consulting"
              className="max-auth-brand__logo"
              width={200}
              height={44}
            />
          )}
        </Link>

        {variant === "login" && (
          <>
            <p className="max-auth-brand__eyebrow">MaX platform · Cloud SaaS</p>
            <h1 className="max-auth-brand__title max-auth-brand__title--saas">
              Maintenance, work orders, and plant data — in one secure workspace
            </h1>
            <p className="max-auth-brand__lead">
              Run preventive schedules, track breakdowns and spares, and see OEE and loss trends without
              juggling spreadsheets. Role-based access for operators, engineers, and leadership — audit-ready
              history across your sites.
            </p>
            <ul className="max-auth-brand__saas-points" aria-label="Platform capabilities">
              <li>PM &amp; work order orchestration</li>
              <li>Downtime, OEE, and reporting</li>
              <li>Safety workflows &amp; multi-plant access</li>
            </ul>
          </>
        )}

        {variant === "register" && (
          <>
            <p className="max-auth-brand__eyebrow">New customer · Onboarding</p>
            <h1 className="max-auth-brand__title max-auth-brand__title--saas">
              Set up your organization on the MaX platform
            </h1>
            <p className="max-auth-brand__lead">
              Create your company workspace and invite administrators. You get a dedicated cloud tenant with secure
              sign-in and data isolation — so your plants, users, and history stay separate from other customers.
            </p>
            <ul className="max-auth-brand__saas-points" aria-label="What you’ll set up">
              <li>Company profile &amp; tenant provisioning</li>
              <li>Admin invites &amp; role-based access</li>
              <li>Plants and sites as you expand</li>
            </ul>
          </>
        )}

        {variant === "default" && (
          <>
            <p className="max-auth-brand__eyebrow">Manufacturing · Operations · Digital</p>
            <h1 className="max-auth-brand__title">
              Consulting depth.
              <span className="max-auth-brand__title-line"> Software scale.</span>
            </h1>
            <p className="max-auth-brand__lead">
              MaX Consulting — over 30 years of manufacturing experience. Advisory, implementation, and the MaX
              platform for how plants actually run.
            </p>
            <p className="max-auth-brand__pillars-line">Zero defect · Zero downtime · Zero incident</p>
          </>
        )}
      </div>
    </div>
  );
};

export default MaxAuthBrandPanel;
